/**
 * Trigger a browser download for text we already hold in memory.
 *
 * Kept out of the component so the export flow can be tested by asserting
 * "was this called with the right filename", rather than by simulating an
 * anchor click in jsdom.
 */
export const downloadTextFile = (
	content: string,
	filename: string,
	contentType = "text/csv;charset=utf-8",
): void => {
	const blob = new Blob([content], { type: contentType })
	const url = URL.createObjectURL(blob)
	const anchor = document.createElement("a")
	anchor.href = url
	anchor.download = filename
	document.body.appendChild(anchor)
	anchor.click()
	anchor.remove()
	// Release the object URL — without this the blob is pinned for the
	// lifetime of the document, and this is a page people sit on all day.
	URL.revokeObjectURL(url)
}

/**
 * `shipments-2026-08-03.csv`, or `shipments-BJ-2026-08-03.csv` under a country
 * scope. Dated because these land in a Downloads folder alongside last week's.
 */
export const scopedExportFilename = (
	base: string,
	scope: { country?: string | undefined } | undefined,
	now: Date,
): string => {
	const date = now.toISOString().slice(0, 10)
	const country = scope?.country
	return country ? `${base}-${country}-${date}.csv` : `${base}-${date}.csv`
}
